import './appHeader.css'

import CommonIcon from 'CommonIcon'
import { Logo } from 'components'
import type { Moment } from 'moment'
import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { getMomentDate } from 'utils'

import Box from '@mui/material/Box'

import useStyles from './useStyles'

interface Props {
  fetchTime?: Moment | null
  hideFetchTime?: boolean
  refreshData?: () => void
  selectedDate: Moment
  showMenuIcon: boolean
  toggleMenu: () => void
  variant?: 'default' | 'dark'
}

function AppHeader({ fetchTime, hideFetchTime, refreshData, selectedDate, showMenuIcon, toggleMenu, variant = 'default' }: Props) {
  const classes = useStyles()
  const { t: translate } = useTranslation()
  const formattedDate = getMomentDate(selectedDate).format('L')

  const renderRight = () => {
    if (fetchTime && !hideFetchTime) {
      return (
        <Box className="refresh-time" onClick={() => refreshData?.()}>
          {fetchTime.format('LT')}
          <i className="fm fm-refresh" />
        </Box>
      )
    }

    if (showMenuIcon) {
      return <Box className="app-header_fake-element" />
    }

    return null
  }

  return (
    <Box className="app-header">
      {showMenuIcon && (
        <Box className="app-header_menu-icon">
          <Box className="fm fm-menu" onClick={toggleMenu} />
        </Box>
      )}
      <Box className="app-header_logo">
        <h1>
          {translate('menu.title')}
          <span className="app-header_info">{translate('menu.date', { date: formattedDate })}</span>
        </h1>
        {variant === 'default' && <Logo />}
        {variant === 'dark' && <CommonIcon className={classes.logo} name="cccLogo" />}
      </Box>
      {renderRight()}
    </Box>
  )
}

export default memo<Props>(AppHeader)
